module.exports = __webpack_public_path__ + "static/TlwgTypewriter-BoldOblique-aa9d36d64ccbbcc2c134b414e87f9d00.woff2";